const TAURI_ACQUIRING_RETURN_URL = "http://localhost:52054";

export const getAcquiringReturnUrl = (isTauri: boolean): string =>
	isTauri ? TAURI_ACQUIRING_RETURN_URL : window.location.href;
